import {Component, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {MatDialog, MatDialogModule} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {TranslateModule} from '@ngx-translate/core';
import {FlexLayoutModule} from '@angular/flex-layout';
import {AuthenticationService} from '../../services/authentication.service';
import {AlertComponent} from '../../../shared/components/dialogs/alert/alert.component';
import {of, switchMap} from 'rxjs';
import {catchError, finalize} from 'rxjs/operators';
import { environment } from '../../../../environments/environment';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    TranslateModule,
    FlexLayoutModule,
  ]
})
export class LoginComponent implements OnInit {

  hidePassword = true;
  processingRequest = false;
  loginForm!: FormGroup;

  redirectUrl: string = '';

  constructor(
    private authenticationService: AuthenticationService,
    private formBuilder: FormBuilder,
    private router: Router,
    private dialog: MatDialog,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      login: ['', Validators.required],
      password: ['', Validators.required],
    });
    this.redirectUrl = this.route.snapshot.queryParams['redirect'] || 'orders-dashboard';
    if (this.authenticationService.isAuthenticated) {
      this.router.navigate([this.redirectUrl]);
    }
  }

  login() {
    this.authenticationService.isSSO = false;
    this.processingRequest = true;

    this.authenticationService.authenticate({ ...this.loginForm.value }).pipe(
      switchMap(() =>
        this.authenticationService.verifyExists(this.loginForm.value.login)
      ),
      finalize(() => this.processingRequest = false)
    ).subscribe({
      next: (user) => {
        if (user) {
          localStorage.setItem('username', this.loginForm.value.login);
          this.router.navigate([this.redirectUrl]);
        } else {
          this.dialog.open(AlertComponent, {
            disableClose: true,
            data: {
              message: 'authentication.access-denied',
              param: null,
              title: 'alert.information',
            },
          });
        }
      },
      error: (error) => {
        const errorMessage = error.status === 429
          ? 'authentication.too-many-requests'
          : 'authentication.access-denied';

        this.dialog.open(AlertComponent, {
          disableClose: true,
          data: {
            message: errorMessage,
            param: null,
            title: 'alert.information',
          },
        });
      }
    });
  }

  loginBySSO() {
    this.authenticationService.isSSO = true;
    window.location.href = `${environment.ssoUrl}/authorization/oauth2/authorize?response_type=code` +
      `&client_id=${environment.clientId}` +
      `&redirect_uri=${environment.redirectUri}` +
      `&code_chalenge=code` +
      '&code_chalenge_method=plain'
  }

  enterSubmit(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.login();
    }
  }

  togglePasswordVisibility() {
    this.hidePassword = !this.hidePassword;
  }
}
